import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { GetValueFieldsQueryResponse, GetValueFieldsQueryParams, GetValueFields400, GetValueFields401, GetValueFields403, GetValueFields422, GetValueFields429, GetValueFields500 } from "../types/GetValueFields";

export const getValueFieldsQueryKey = (params: GetValueFieldsQueryParams) =>     [{url:`/api/purchase-tenders/v1/value-fields`},...(params ? [params] : [])] as const;
      export function getValueFieldsQueryOptions <TData = GetValueFieldsQueryResponse, TError = GetValueFields400 | GetValueFields401 | GetValueFields403 | GetValueFields422 | GetValueFields429 | GetValueFields500>(params: GetValueFieldsQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = getValueFieldsQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/purchase-tenders/v1/value-fields`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/purchase-tenders/v1/value-fields
 */

export function useGetValueFields <TData = GetValueFieldsQueryResponse, TError = GetValueFields400 | GetValueFields401 | GetValueFields403 | GetValueFields422 | GetValueFields429 | GetValueFields500>(params: GetValueFieldsQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? getValueFieldsQueryKey(params);

  const query = useQuery<TData, TError>({
    ...getValueFieldsQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
